module.exports = __webpack_public_path__ + "static/img/banner_job.79e70f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_job.jpg
// module id = bd73
// module chunks = 2